import type { FaireProductEntity } from "../../entity_types/product";

export const p_twyhswjnxs: FaireProductEntity = {
  token: "p_twyhswjnxs",
  type: "product",
  name: "Dubai Chocolate Pistachio Bites by Oasis Treasures (80g)",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl:
    "https://cdn.faire.com/fastly/083c61676c675b6f5e6869fea0a6c00b8b0be5dbdb58c78217069d4ca5bd2ac2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5c68c24eb81b95797c8b85e2578b9e9d41baac35b49b16389bd395ccc315a13.jpeg",
    "https://cdn.faire.com/fastly/70944e368f0da6ee9f027e7f03195cd20853f6aa64d5cc660e8de6dc97091179.jpeg",
    "https://cdn.faire.com/fastly/2883895e2e320dce37ef1485b3b76f8d64995d9d82612ec757e6a5883ef437c5.jpeg",
  ],
  priceDollars: 5.53,
  description:
    "Step Into the World of Luxurious Flavors\n\nElevate your assortment with Dubai Chocolate Bites by Oasis Treasures, a premium confection that blends Middle Eastern tradition with indulgent chocolate craftsmanship. Each bite features a velvety milk chocolate shell filled with pistachio white chocolate and creamy pistachio filling, delivering the perfect balance of sweetness and nutty richness.\n\nInside, a crispy knafeh center pays homage to one of the Middle East’s most beloved pastries, adding a satisfying crunch that contrasts beautifully with the smooth, creamy layers. This combination of flavors and textures creates a multisensory experience that delights chocolate lovers and adventurous foodies alike.\n\nKey Selling Points\n\nPremium ingredients sourced from the UAE\n\nUnique blend of pistachio cream + knafeh crunch\n\nDistinctive Middle Eastern flair sets it apart from everyday chocolates\n\nPerfect for specialty retail, gourmet gifting, and impulse displays\n\nOffer your customers a true taste of Dubai with this decadent, one-of-a-kind treat that drives trial, gifting, and repeat purchases.\n",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:12.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
